import Vue from 'vue';
import Router from 'vue-router';
import MetaInfo from 'vue-meta-info';
import MainScreen from '../views/MainScreen';
import GameScreen from '../views/GameScreen';
import EndingScreen from '../views/EndingScreen';
import ExtraScreen from '@/views/ExtraScreen';

Vue.use(Router);
Vue.use(MetaInfo);

let routes = [
    {
        path: '/',
        name: 'MainScreen',
        component: MainScreen
    },
    {
        path: '/play',
        name: 'GameScreen',
        component: GameScreen
    },
    {
        path: '/ending',
        name: 'EndingScreen',
        component: EndingScreen
    },
    {
        path: '/bonus-stage',
        name: 'ExtraScreen',
        component: ExtraScreen
    },

    {
        path: '/*',
        redirect: {
            name: 'MainScreen'
        }
    }
];

export default new Router({
    routes
});
